    <div class="event-page">
      <app-map 
        class="map-container">
      </app-map>
    </div>